import React, {useState} from "react";
import searchicon from '../Assets/images/search_primary.png';
import { IconButton, Typography } from "@mui/material";
import BiztantuSearchDialog from "./BiztantuSearchDialog";
import { handleValidateCodevalue } from "../Utility/constant";
import TextFiledWithLabel from "./TextFieldWithLabel";
import { useSelector } from "react-redux";
import { StyledSearchContainer } from "./Styled";
import { useIsMobile } from "../Utility/hooks/useIsMobile";
import SearchIcon from '@mui/icons-material/Search';

const BiztantuSearch = ({showDates=true ,children , handleReset,entityDetails,handleSearch,showOwner = false, showStatus = true, maxWidth = "lg" }) => {
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const [dialog, setDialog] = useState({
        isOpen: false,
        data: null
    });
    const isMobile = useIsMobile();

    const ignoredFields = ['ownerId', 'updatedFrom', 'updatedTo','selectedOwner','productType','runOnce','ownerName','clientName'];

    const extraFieldCount = Object.keys(entityDetails || {}).filter(key => {
    const value = entityDetails[key];
    return !ignoredFields.includes(key) && value != null && value !== "";
    });
    const count = extraFieldCount?.length


    const handleOpenDialog = () => {
        setDialog({
            ...dialog,
            isOpen: true
        });
    }

    const handleCloseDialog = () => {

         setDialog({
            ...dialog,
            isOpen: false
        });

    }


if (isMobile) {
  return (
    <>
       <div className="height_100" style = {{backgroundColor:"#f4f9fe"}}>
            <IconButton className = "biztantu-search-icon" onClick={handleOpenDialog}>
                <SearchIcon/>
            </IconButton>
        </div>
      <BiztantuSearchDialog
        handleReset={handleReset}
        handleSearch={handleSearch}
        data={dialog}
        handleCloseDialog={handleCloseDialog}
        maxWidth={maxWidth}
      >
        {children}
      </BiztantuSearchDialog>
    </>
  );
}

    return (
        <>
           <StyledSearchContainer className='table-header-search'  sx ={{gap : 2, marginTop: "", backgroundColor: "white"}}>
            
                {showDates &&
                <>
                <TextFiledWithLabel
                    disabled = {true}
                    id="updatedFrom"
                    name="updatedFrom"
                    className="search-page-textfields"
                    type="date"
                    value = {entityDetails?.updatedFrom}
                    label={handleValidateCodevalue(internationalise,"COMMON_UPDATED_FROM")}
                />
                <TextFiledWithLabel
                    disabled = {true}
                    id="updatedTo"
                    name="updatedTo"
                    className="search-page-textfields"
                    type="date"
                    value = {entityDetails?.updatedTo}
                    label={handleValidateCodevalue(internationalise,"COMMON_UPDATED_TO")}
                />
                </>
                }
                
                {!showDates &&
                <>
                    <TextFiledWithLabel
                        disabled={true}
                        className="search-page-textfields"
                        label={handleValidateCodevalue(internationalise, "AUDI_SEARCH_ENTITY")}
                        value={handleValidateCodevalue(internationalise,entityDetails?.entity) || ""}
                    />
                    <TextFiledWithLabel
                        disabled={true}
                        className="search-page-textfields"
                        label={handleValidateCodevalue(internationalise, "AUDI_SEARCH_REF_ID")}
                        value={entityDetails?.entityId || ""}
                    />
                    </>
                }
                {showOwner &&
                 <TextFiledWithLabel
                    disabled = {true}
                    label={handleValidateCodevalue(internationalise,"COMMON_SEARCH_OWNER")}
                    value={handleValidateCodevalue(internationalise,(entityDetails?.ownerName || ""))}
                    className="search-page-textfields"
                />
                }
                {showStatus &&
                <TextFiledWithLabel
                    disabled = {true}
                    className="search-page-textfields"
                    label={handleValidateCodevalue(internationalise,"COMMON_SEARCH_STATUS")}
                    value={handleValidateCodevalue(internationalise,entityDetails?.status)}
                />
                }
                {!showStatus && entityDetails?.clientName &&
                <TextFiledWithLabel
                    disabled = {true}
                    className="search-page-textfields"
                    label={handleValidateCodevalue(internationalise,"CONF_USER_SEARCH_CLIENT")}
                    value={entityDetails?.clientName}
                />
                }
                <Typography onClick={handleOpenDialog} variant="body1" sx={{color: "#9F9F9F", cursor: "pointer"}}>
                    {count>0 ? `+${count} ${handleValidateCodevalue(internationalise,"COMMON_SEARCH_COUNT_MORE")}` : ""}
                </Typography>
                <div className="height_100">
                    <IconButton className = "biztantu-search-icon" onClick={handleOpenDialog}>
                        <SearchIcon/>
                    </IconButton>
                </div>
            </StyledSearchContainer> 

            <BiztantuSearchDialog
                handleReset = {handleReset}
                handleSearch = {handleSearch}
                data = {dialog}
                handleCloseDialog = {handleCloseDialog}
                maxWidth={maxWidth}
            >
                {children}
            </BiztantuSearchDialog>
        </>
    )
}

export default BiztantuSearch;